import React, { Fragment } from "react";
import { Card, Row, Col, Button } from 'react-bootstrap';
import '../../../../../styles/leis-auth.scss'

const Lic = (props) => {

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchLicsIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    const setVer = async (id) => {
        props.ver(id)
    }

    const setSituacao = async (id) => {
        props.situacao(id)
    }

    const setAndamento = async (id) => {
        props.andamento(id)
    }

    const setHomologar = async (id) => {
        props.homologar(id)
    }

    const setCancelar = async (id) => {
        props.cancelar(id)
    }

    const setValor = async (id) => {
        props.valor(id)
    }
    const setObjeto = async (id) => {
        props.objeto(id)
    }
    const setArquivo = async (id) => {
        props.arquivo(id)
    }

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Row xs={1} lg={3}>
                        <Col lg={6}>
                            <Card.Body>
                                <Card.Title className="cabeca-card cb-lic" key={props.key}>Processo Nº{props.lic.processo}/{props.lic.ano} <br />
                                    {props.lic.modalidade} Nº{props.lic.licitacao}<br />
                                    Situação: {props.lic.situacao} <br />
                                    Objeto: {props.lic.objeto}<br />
                                </Card.Title>
                            </Card.Body>
                        </Col>
                        <Col lg={3}>
                            <Button type="button" className="botao-leis" onClick={() => editar(props.lic._id)} variant='primary'>Editar</Button>
                            <Button type="button" className="botao-leis" onClick={() => setVer(props.lic._id)} variant='primary'>Ver Licitação</Button>
                            {props.situacao ? <Button type="button" className="botao-leis" onClick={() => setSituacao(props.lic._id)} variant='primary'>Mudar Situação</Button> : ''}
                            {props.valor ? <Button type='button' className="botao-leis" onClick={() => setValor(props.lic._id)} variant='primary'>Alterar Valor</Button> : ''}
                        </Col>
                        <Col lg={3}>
                            <Button type='button' className="botao-leis" onClick={() => setObjeto(props.lic._id)} variant='primary'>Alterar Objeto</Button>
                            <Button type='button' className="botao-leis" onClick={() => setArquivo(props.lic._id)} variant='primary'>Anexar Arquivo</Button>
                            {props.andamento ? <Button type="button" className="botao-leis" onClick={() => setAndamento(props.lic._id)} variant='success'>Dar Andamento</Button> : ''}
                            {props.homologar ? <Button type="button" className="botao-leis" onClick={() => setHomologar(props.lic._id)} variant='success'>Homologar</Button> : ''}
                            {props.cancelar ? <Button type="button" className="botao-leis" onClick={() => setCancelar(props.lic._id)} variant='warning'>Cancelar</Button> : ''}
                            <Button type='button' className="botao-leis" onClick={() => deletar(props.lic._id)} variant='danger'>Excluir</Button>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Fragment >)
}

export default Lic;